import React from 'react';
import AsyncSection from '../../../../../../../../../../Components/AsyncSection';
import './index.scss';
import { formatDelta } from '../../constants';
import {
    COLUMNS,
    HEADER_TEXT,
    MOVEMENT_LABEL,
    NO_VALUE,
    hasGap,
    movementFor,
    movementToneFor,
} from './constants';

const formatGap = (gap) => (hasGap(gap) ? formatDelta(gap) : NO_VALUE);

// Whether the Self vs All But Self gap closed between the two rounds, per
// category. A real table rather than divs: it's four labelled columns of
// numbers, and the row order is the source's, not something the reader sorts.
const BlindSpotShrink = (props) => {
    const api = props.fetchTrendSelfVsOthersApi;
    const rows = api.data && api.data.data ? api.data.data : [];

    return (
        <AsyncSection api={api} isEmpty={() => !rows.length} loaderHeight={300} loaderWidth={600}>
        <div className='cardwrapper'>
            <h3>{HEADER_TEXT.title}</h3>
            <p className='description-container'>{HEADER_TEXT.description}</p>

            <div className='blindspot'>
                <div className='blindspot__table-wrap'>
                    <table className='blindspot__table'>
                        <thead>
                            <tr>
                                <th className='blindspot__th blindspot__th--category'>{COLUMNS.category}</th>
                                <th className='blindspot__th blindspot__th--gap'>{COLUMNS.gapEarlier}</th>
                                <th className='blindspot__th blindspot__th--gap'>{COLUMNS.gapLatest}</th>
                                <th className='blindspot__th blindspot__th--movement'>{COLUMNS.movement}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row) => {
                                const movement = movementFor(row);
                                const tone = movement != null ? movementToneFor(movement) : null;
                                return (
                                    <tr key={row.category}>
                                        <td className='blindspot__td blindspot__td--category'>{row.category}</td>
                                        <td className='blindspot__td blindspot__td--gap'>{formatGap(row.gapEarlier)}</td>
                                        <td className='blindspot__td blindspot__td--gap'>{formatGap(row.gapLatest)}</td>
                                        <td className='blindspot__td blindspot__td--movement'>
                                            {tone ? (
                                                <span className={`blindspot__movement blindspot__movement--${tone}`}>
                                                    {MOVEMENT_LABEL[tone]} ({formatDelta(movement)})
                                                </span>
                                            ) : NO_VALUE}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                <p className='blindspot__note'>{HEADER_TEXT.note}</p>
            </div>
        </div>
        </AsyncSection>
    );
};

export default BlindSpotShrink;
